import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewLeaveTypeForm from "./NewLeaveType.jsx";
import {
	GET_LEAVE_TYPE,
	NEW_LEAVE_TYPE,
	UPDATE_LEAVE_TYPE
} from "../../../queries/leave-type.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import auth from "../../../providers/Auth.Provider";
import LeaveTypeList from "./LeaveTypeList";
import UpdateLeaveType from "./UpdateLeaveType";

const LeaveType = ({ match }) => {
	// local state
	const [newLeaveType, setNewLeaveType] = useState(false);
	const [department, setLeaveType] = useState(null);
	// site
	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// prepare query
	const {
		loading: gLoading,
		data: gData,
		error: gError
	} = useQuery(GET_LEAVE_TYPE, { variables: { site: site && site.id } });

	// prepare mutation
	const [
		CreateLeaveType,
		{ loading: nLoading, data: nData, error: nError }
	] = useMutation(NEW_LEAVE_TYPE, {
		update(caches, { data: { CreateLeaveType } }) {
			const { GetLeaveTypes } = caches.readQuery({
				query: GET_LEAVE_TYPE,
				variables: { site: site && site.id }
			});
			// update
			GetLeaveTypes.docs.unshift(CreateLeaveType.doc);
			// write back
			caches.writeQuery({
				data: { GetLeaveTypes },
				variables: { site: site && site.id },
				query: GET_LEAVE_TYPE
			});
		}
	});

	// prepare Update mutation
	const [
		UpdateLeaveTypeFunc,
		{ loading: uLoading, data: uData, error: uError }
	] = useMutation(UPDATE_LEAVE_TYPE);
	// props
	const title = "Staff Leave Type";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{newLeaveType && (
					<div className="col-md-10 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New LeaveType</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={nLoading} />
								<AlertMessage
									message={nError && nError.message}
									failed={true}
								/>
								<AlertMessage
									message={
										nData && nData.CreateLeaveType.message
									}
									failed={false}
								/>
								<NewLeaveTypeForm
									onCancel={() => setNewLeaveType(false)}
									onSubmit={async name => {
										await CreateLeaveType({
											variables: {
												site: site && site.id,
												name
											}
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{department && (
					<div className="col-md-10 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Update LeaveType</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage
									message={
										uData && uData.UpdateLeaveType.message
									}
									failed={false}
								/>
								<h5>{department.name}: </h5>
								<UpdateLeaveType
									onCancel={() => {
										setLeaveType(null);
										setNewLeaveType(false);
									}}
									onSubmit={async name => {
										await UpdateLeaveTypeFunc({
											variables: {
												id: department.id,
												name
											}
										});
										setLeaveType(null);
									}}
									currentValue={department.name}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="col-md-10 col-sm-12">
					<div className="card">
						<div className="card-head">
							<header>Leave Types</header>
							<div className="tools">
								<button
									title="Add LeaveType"
									onClick={() => {
										setNewLeaveType(true);
										setLeaveType(null);
									}}
									className="mdl-button mdl-button--icon margin-right-10 btn-success"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={gLoading} />
							<AlertMessage
								message={gError && gError.message}
								failed={true}
							/>
							{!gLoading && (
								<LeaveTypeList
									items={gData && gData.GetLeaveTypes.docs}
									onEdit={item => {
										setLeaveType(item);
										setNewLeaveType(false);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default LeaveType;
